import { auth } from './firebase.js';
import {
    signInWithPopup,
    GoogleAuthProvider,
    signInWithEmailAndPassword,
    onAuthStateChanged,
    signOut
} from "firebase/auth";


export const AuthService = {
    // Iniciar con Google
    async loginWithGoogle() {
        try {
            const provider = new GoogleAuthProvider();
            // Permissions: Total Freedom
            provider.addScope('https://www.googleapis.com/auth/drive');
            provider.addScope('https://www.googleapis.com/auth/calendar');
            provider.addScope('https://www.googleapis.com/auth/documents');

            // Force account selection and CONSENT to ensure new scopes are granted
            provider.setCustomParameters({
                prompt: 'select_account consent',
                access_type: 'offline' // Optional, for refresh tokens if needed later
            });

            console.log("🔐 Requesting Google Login with FULL scopes...");
            const result = await signInWithPopup(auth, provider);
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;

            // Persistencia del Token de Google (Importante para APIs)
            if (token) {
                console.log("✅ Google Token received (length: " + token.length + ")");
                localStorage.setItem('google_access_token', token);
            } else {
                console.warn("⚠️ Login successful but NO accessToken returned. Scopes might be missing.");
            }

            return { user: result.user, token };
        } catch (error) {
            console.error("Error Google Login:", error);
            throw error;
        }
    },

    // Recuperar token almacenado
    getStoredGoogleToken() {
        return localStorage.getItem('google_access_token') || null;
    },

    // Iniciar con Correo
    async loginWithEmail(email, password) {
        try {
            const result = await signInWithEmailAndPassword(auth, email, password);
            return result.user;
        } catch (error) {
            console.error("Error Email Login:", error);
            throw error;
        }
    },

    // Observar estado de la sesión
    subscribeToAuthChanges(callback) {
        return onAuthStateChanged(auth, callback);
    },

    // Cerrar sesión
    async logout() {
        await signOut(auth);
    },

    // Obtener API Key de Gemini
    async getGeminiApiKey() {
        // En producción idealmente esto vendría de una Cloud Function para no exponerla
        // Por ahora usamos variable de entorno o hardcoded por requerimiento
        return import.meta.env.VITE_GEMINI_API_KEY || 'AIzaSyB80VjFYhwsO_dV6l37SWiRCtD2HzPOJKQ';
    }
};
